import { useGetPricingTypes } from "../../../hooks/api/queries/useInventory";
import { useState, useContext } from "react";
import { RequestLoader, ToastContext } from "../../../hooks/context";
import { cleanObject, getRandomIntInclusive } from "../../../helpers";
import {
  useBulkDeleteProductPrice,
  useBulkUpdateProductPrice,
} from "../../../hooks/api/mutations/useInventory";
import { useParams, useSearchParams } from "react-router-dom";
import { removeCommas } from "../../../helpers";

const BulkEditProductLogic = ({
  selectedData,
  type = "PRODUCT",
  setSelectedData = () => {},
  closeModal = () => {},
}) => {
  const [controlPrice, setControlPrice] = useState();
  const triggerToast = useContext(ToastContext);
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const { store_id } = useParams();
  const [search] = useSearchParams();
  const [isAdjusting, setIsAdjusting] = useState(false);
  const [deleteType, setDeleteType] = useState(null);
  const [productsDetails, setProductsDetails] = useState({
    store_id: search.get("store_id") || store_id,
    pricing_type_id: "",
    adjustment_type: "PERCENTAGE",
    decrease_percentage: "",
    increase_percentage: "",
    decrease_amount: "",
    increase_amount: "",
  });

  const { data: pricingTypes, isLoading: isLoadingPricingTypes } =
    useGetPricingTypes();
  const createBulkUpdateProductPriceMutation = useBulkUpdateProductPrice();
  const createBulkDeleteProductPriceMutation = useBulkDeleteProductPrice();

  const reset = () => {
    setSelectedData({
      is_select_all: false,
      selected_ids: [],
      exclude_selected_ids: [],
    });
  };

  const getSelectedData = (isViaDelete = true) => {
    let is_select_all;

    if (isViaDelete)
      is_select_all = deleteType === "ONLY_SELECTED" ? false : true;
    else is_select_all = selectedData?.is_select_all;

    const selectedProducts = is_select_all
      ? selectedData?.exclude_selected_ids
      : selectedData?.selected_ids;

    const itemKey = is_select_all ? "exclude_selected_ids" : "selected_ids";

    const items_ids = selectedProducts?.map((item) => {
      const itemSplit = `${item}`?.split("--");

      return cleanObject({
        product_id: String(itemSplit?.[0]),
        variant_id: itemSplit?.[1] ? String(itemSplit?.[1]) : undefined,
      });
    });

    return {
      [itemKey]: items_ids,
      is_select_all: is_select_all,
      item_type: type,
    };
  };

  const handleBulkEditProduct = () => {
    if (!controlPrice) {
      triggerToast(
        "Please select an adjustment action (Increase or Decrease)",
        "warning",
      );
      return;
    }

    const isPercentage = productsDetails.adjustment_type === "PERCENTAGE";
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const itemData = getSelectedData(false);

    const data = cleanObject({
      store_id: productsDetails.store_id,
      pricing_type_id: productsDetails.pricing_type_id,
      adjustment_type: productsDetails.adjustment_type,
      ...(isPercentage
        ? controlPrice === "+"
          ? { increase_percentage: productsDetails.increase_percentage }
          : { decrease_percentage: productsDetails.decrease_percentage }
        : controlPrice === "+"
          ? {
              increase_amount: removeCommas(
                String(productsDetails.increase_amount),
              ),
            }
          : {
              decrease_amount: removeCommas(
                String(productsDetails.decrease_amount),
              ),
            }),
      ...itemData,
    });

    createBulkUpdateProductPriceMutation.mutate(data, {
      onSuccess: () => {
        reset();
        triggerToast("Product price updated successfully", "success");
        closeModal();
      },
      onSettled: () => setRequestLoaderProgress(100),
    });
  };

  const handleBulkDeleteProduct = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));

    const data = getSelectedData();

    createBulkDeleteProductPriceMutation.mutate(
      {
        store_id: search.get("store_id") || store_id,
        data: cleanObject({
          ...data,
        }),
      },
      {
        onSuccess: () => {
          reset();
          triggerToast("Product deleted successfully", "success");
          closeModal();
        },
        onSettled: () => setRequestLoaderProgress(100),
      },
    );
  };

  return {
    isUpdatingPrice: createBulkUpdateProductPriceMutation?.isLoading,
    isDeletingProduct: createBulkDeleteProductPriceMutation?.isLoading,
    pricingTypes,
    isLoadingPricingTypes,
    productsDetails,
    controlPrice,
    isAdjusting,
    deleteType,
    setDeleteType,
    setIsAdjusting,
    handleBulkEditProduct,
    setControlPrice,
    setProductsDetails,
    handleBulkDeleteProduct,
  };
};

export default BulkEditProductLogic;
